import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=0ae01bf3&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae01bf3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae01bf3')) {
      api.createRecord('0ae01bf3', component.options)
    } else {
      api.reload('0ae01bf3', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=0ae01bf3&scoped=true", function () {
      api.rerender('0ae01bf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/article/edit.vue"
export default component.exports